import type { GdprConfig } from './types';

declare const gdpr_object: GdprConfig | undefined;

let _config: GdprConfig | null = null;

export function getConfig(): GdprConfig | null {
    if (_config) return _config;
    if (typeof gdpr_object === 'undefined') return null;
    _config = gdpr_object;
    return _config;
}

export function isConfigAvailable(): boolean {
    return typeof gdpr_object !== 'undefined';
}
